import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../../app/store';
// import { IS_APP_SANDBOX } from "../../app.config";

type SandboxState = {
  sandbox: boolean;
};

const initialState: SandboxState = {
  sandbox: false //IS_APP_SANDBOX,
};

export const slice = createSlice({
  name: 'sandbox',
  initialState,
  reducers: {
    sandbox: (state, action: PayloadAction<boolean>) => {
      state.sandbox = action.payload;
    },
  },
});

export const { sandbox } = slice.actions;

export const setSandbox =
  (flag: boolean): AppThunk =>
    (dispatch) => {
      dispatch(sandbox(flag));
    };

export const selectSandbox = (state: RootState) => state.sandbox.sandbox;

export default slice.reducer;
